import React, { forwardRef, Fragment, useEffect, useMemo, useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Dialog,
  DialogContent,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { motion } from 'framer-motion';
import Feed from '../feed';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';
import FilterMenuButton from '../common/FilterMenuButton';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});



export default function SearchDialogUp({ openSearch = false, setOpenSearch, matches, chipTitle }) {
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(false);

  // remark 标记词
  const isRemark = [
    "淫妻",
    "淫妻绿帽",
    "东京热",
    "Sperm",
    "夜未央",
    "周排行榜",
    "科幻",
    "ED Mosaic"
  ].includes(chipTitle);

  const handleClose = () => setOpenSearch(false);

  // 加载第一页数据（不带滚动）
  useEffect(() => {
    if (!openSearch || !chipTitle) return;

    setLoading(true);
    setEmpty(false);
    setLatest([]);

    const fetchData = async () => {
      try {
        const res = await fetch(
          `${DOMAIN}ywyminiappbot/search?caption=${encodeURIComponent(chipTitle)}&page=1`
        );
        const data = await res.json();
        if (!data || data.length === 0) {
          setEmpty(true);
        } else {
          setLatest(data);
        }
      } catch (err) {
        console.error("SearchDialogUp fetch error:", err);
        setEmpty(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [openSearch, chipTitle]);

  const handleFilterChange = (newFilter) => {
    setFilterResult(newFilter);
    const filterStr = `filter+${encodeURIComponent(JSON.stringify(newFilter))}`;
    setReset(filterStr); // Feed 内部会监听 reset
  }

  const [filterResult, setFilterResult] = useState({
      sort: "最新发布",
      categories: [],
    });
  const [reset, setReset] = useState(false);

  // ✅ memo 化 feed URL，避免每次 render 都生成新字符串
  const feedUrl = useMemo(() => {
    const baseUrl = `${DOMAIN}ywyminiappbot/search?caption=${encodeURIComponent(chipTitle || "")}`;
    const params = new URLSearchParams();
    params.append("sort", filterResult?.sort || "最新发布");
    if (filterResult?.categories?.length > 0) {
      params.append("categories", filterResult.categories.join(","));
    }
    return `${baseUrl}?${params.toString()}`;
  }, [chipTitle, filterResult]);

  return (
    <Fragment>
      <Dialog
        fullScreen
        open={openSearch}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {/* 顶部 AppBar */}
        <AppBar
          sx={{
            position: 'sticky',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(255,255,255,0.25)',
            color: '#000',
            boxShadow: 'none',
          }}
        >
          <Toolbar>
            <motion.div
              initial={{ x: '100%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, ease: 'easeOut' }}
              style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}
            >
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: 16, flex: 1 }}>
                {chipTitle}
              </Typography>
              {/* 右侧：FilterMenuButton */}
              <FilterMenuButton onChange={handleFilterChange} CATEGORY_OPTIONS={[]} />
            </motion.div>
          </Toolbar>
        </AppBar>

        {/* 内容区域 */}
        <DialogContent sx={{ padding: 0, paddingTop: 45, position: 'relative' }}>
          {loading && <CustomizedProgressBars />}

          {!loading && empty && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                padding: '200px 0',
                color: '#999',
                gap: 1,
              }}
            >
              <SearchOffIcon />
              <Typography variant="h6" fontSize={14}>
                没有此内容，我们会尽快发布...
              </Typography>
            </Box>
          )}

          {/* ✅ 保持 Feed 永远挂载，reset 控制内部逻辑 */}
          <Feed
            matches={matches}
            latest={latest || []}
            setLatest={setLatest}
            title={chipTitle}
            remark={isRemark}
            fetchUrl={feedUrl}
            reset={reset}
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
